import Card from './../components/ServiceCard';
import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import DetailsHeading from './../components/DetailsHeading';
import Counsel from './../assets/Svgs/remote.svg'
import Contract from './../assets/Svgs/contract.svg'
import Compliance from './../assets/Svgs/risk.svg'
import Property from './../assets/Svgs/property.svg'
import { Link } from 'react-router-dom';

function MainServiceSection() {
  return (
    <section id="services" className='py-10'>
      <SmallHeading name="Our Key Services" tstyle="text-center my-1 mt-10"/>
      <Heading name="Supporting Your Goals Every Step of the Way" tstyle="text-center my-1"/>
      <div className='mt-4 px-10' >
        <DetailsHeading 
        name="At PocketLPO, we offer flexible, cost-effective, and comprehensive legal solutions
        tailored to your business needs, with scalable services that you can access anytime, anywhere.
          Benefit from a wide range of expertise, from corporate governance to intellectual property management, all through our advanced platform." 
        tstyle="my-1"
        />

      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-10 mx-10 mb-8">
        <Card
          heading="Remote In-House Counsel"
          image={Counsel}
          description='Act as an extension of your team with our dedicated legal experts, accessible anytime and anywhere.'
          linkText='services/remote-in-house-counsel'
        />
        <Card
          heading="Contract Management & Review"
          image={Contract}
          description='Simplify your contract processes with our drafting, reviewing, and management services to ensure your interests are protected.'
          linkText='services/contract-drafting-and-management'
        />
        <Card
          heading="Compliance and Risk Management"
          image={Compliance}
          description='Navigate regulatory landscapes confidently with our comprehensive compliance services, mitigating risks effectively.'
          linkText='services/corporate-governance-and-compliance'
        />
        <Card
          heading="Intellectual Property Services"
          image={Property}
          description='Safeguard your innovations with our IP management services, including trademark registration and portfolio management.'
          linkText='services/intellectual-property-services'
        />
      </div>
      <div className="flex justify-center">
        <Link 
          to="services"
          onClick={() => window.scrollTo(0, 0)}
          className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1">
          View All Services
        </Link>
      </div>
    </section>
  );
}

export default MainServiceSection;
